"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _remarkBreaks = _interopRequireDefault(require("remark-breaks"));

var _heading = _interopRequireDefault(require("../heading"));

var _paragraph = _interopRequireDefault(require("../paragraph"));

var _index = _interopRequireDefault(require("./index.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Markdown = function Markdown(props) {
  var content = props.content;
  return _react["default"].createElement(_reactMarkdown["default"], {
    skipHtml: true,
    source: content,
    plugins: [_remarkBreaks["default"]],
    className: _index["default"].Markdown,
    renderers: _objectSpread({
      // eslint-disable-next-line react/prop-types
      root: function root(_ref) {
        var children = _ref.children;
        return _react["default"].createElement("div", {
          className: _index["default"].Markdown
        }, children);
      },
      // eslint-disable-next-line react/prop-types
      paragraph: function paragraph(_ref2) {
        var children = _ref2.children;
        return _react["default"].createElement(_paragraph["default"], null, children);
      },
      // eslint-disable-next-line react/prop-types
      heading: function heading(_ref3) {
        var level = _ref3.level,
            children = _ref3.children;
        return _react["default"].createElement(_heading["default"], {
          type: {
            1: 'large',
            2: 'medium',
            3: 'small'
          }[level] || 'extrasmall'
        }, children);
      },
      // eslint-disable-next-line react/prop-types
      tableCell: function tableCell(_ref4) {
        var isHeader = _ref4.isHeader,
            children = _ref4.children;
        return isHeader ? _react["default"].createElement("th", null, _react["default"].createElement(_heading["default"], {
          type: "extrasmall"
        }, children)) : _react["default"].createElement("td", null, children);
      }
    }, props.renderers)
  });
};

Markdown.propTypes = {
  content: _propTypes["default"].string.isRequired
};
var _default = Markdown;
exports["default"] = _default;